import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "master"]

  masterTargetConnected(master) {
    this.#reflect(master)
  }

  toggleGroup(event) {
    const checked = event.target.checked
    this.#itemsFor(event.target).forEach((box) => {
      box.checked = checked
    })
  }

  syncGroup(event) {
    const master = this.#masterFor(event.target)
    if (master) this.#reflect(master)
  }

  checkFieldsWhenUnchecked({ target, params: { fields } }) {
    if (target.checked) return

    fields.forEach((id) => {
      const field = document.getElementById(id)
      field.checked = true
      field.dispatchEvent(new Event("change"))
    })
  }

  stop(event) {
    event.stopPropagation()
  }

  #reflect(master) {
    const items = this.#itemsFor(master)
    const checked = items.filter((box) => box.checked).length
    master.checked = items.length > 0 && checked === items.length
    master.indeterminate = checked > 0 && checked < items.length
  }

  #itemsFor(node) {
    return Array.from(this.#groupFor(node)?.querySelectorAll("[data-checkboxes-target~='item']") || [])
  }

  #masterFor(node) {
    return this.#groupFor(node)?.querySelector("[data-checkboxes-target~='master']")
  }

  #groupFor(node) {
    return node.closest("[data-checkboxes-group]")
  }
}
